/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { UserMessageState, UserMessageSlots } from './UserMessage.types';

/**
 * Render the final JSX of UserMessage
 */
export const renderUserMessage_unstable = (state: UserMessageState): JSXElement => {
  assertSlots<UserMessageSlots>(state);

  return (
    <state.root>
      {state.accessibleHeading && <state.accessibleHeading />}
      {state.timestamp && <state.timestamp />}
      {state.actionBarAccessibleButton && <state.actionBarAccessibleButton />}
      {state.actionBar && <state.actionBar />}
      <state.message />
    </state.root>
  );
};
